import { storyblokEditable } from "@storyblok/react";

const resolveStoryblokLink = (link) => {
  if (!link) return "#";
  if (link.linktype === "story") {
    const slug = link.cached_url || link.story?.full_slug;
    return slug ? `/${slug}` : "#";
  }
  if (link.linktype === "asset") return link.url || "#";
  return link.url || link.cached_url || "#";
};

const ResourceCard = ({ blok, onGateClick }) => {
  const bgImage = blok.background_image?.filename
    ? `url(${blok.background_image.filename})`
    : "none";

  const buttonHref = resolveStoryblokLink(blok.button_url);
  const isGatedCard = !!blok.is_gated_video_card;

  const handleClick = (e) => {
    if (isGatedCard) {
      e.preventDefault();
      // Pass this card's resolved video URL up to the parent
      onGateClick?.(buttonHref);
    }
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className="relative bg-cover bg-center text-white flex flex-col justify-end rounded-lg overflow-hidden h-[390px] shadow-md transition-transform hover:scale-105"
      style={{ backgroundImage: bgImage }}
    >
      <div className="bg-[#10309e]/60 p-6 flex flex-col justify-between h-full">
        {blok.category && (
          <span className="text-sm font-semibold uppercase mb-2">
            {blok.category}
          </span>
        )}

        {blok.title && (
          <h3 className="text-lg font-medium leading-snug mb-6">
            {blok.title}
          </h3>
        )}

        <div className="flex justify-between items-center mt-auto">
          <a
            href={buttonHref}
            onClick={handleClick}
            className="flex items-center gap-2 text-sm font-semibold"
          >
            <span className="hover:underline">{blok.button_text}</span>
            <span className="text-lg no-underline">→</span>
          </a>

          {blok.icon?.filename && (
            <img
              src={blok.icon.filename}
              alt=""
              className="w-[40px] h-[40px] object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;